import React from 'react';
import { CustomPopperStyled } from '../../../styledComponentsStyles';

export default function index(props) {
  return <CustomPopperStyled {...props} placement="bottom-start" />;
}
